<script setup lang="ts">
  import { computed } from 'vue';
  import { storeToRefs } from 'pinia';
  import certificateIcon from '@/shared/assets/icons/CertificateIcon.svg';
  import { useDashboardStore } from '../../model/dashboard.store';
  import { formatPeriodLabel } from '../../model/period';
  import HorizontalBarList, { type HorizontalBarItem } from '../HorizontalBarList.vue';
  import WidgetCard from '../WidgetCard.vue';

  const dashboardStore = useDashboardStore();
  const { data, isLoading, granularity, period } = storeToRefs(dashboardStore);

  const periodLabel = computed(() => formatPeriodLabel(granularity.value, period.value));

  const items = computed<readonly HorizontalBarItem[]>(
    () => data.value?.trainingByDepartment.items ?? []
  );
</script>

<template>
  <WidgetCard
    title="Treinamento por Departamento"
    :icon="certificateIcon"
    :period-label="periodLabel"
    :loading="isLoading"
    :has-data="data !== null"
    skeleton="bar-list"
  >
    <div
      data-testid="training-by-department-widget"
      class="-mr-3 flex h-full min-h-0 items-center"
    >
      <p
        v-if="items.length === 0"
        data-testid="training-by-department-empty"
        class="w-full text-center text-sm text-gray-03"
      >
        Nenhum treinamento no período
      </p>
      <HorizontalBarList
        v-else
        class="max-h-full w-full pr-5"
        :items="items"
      />
    </div>
  </WidgetCard>
</template>
